/* eslint-disable */
// @ts-nocheck
import React from "react";
import { TabList, Tab } from "@carbon/react";
import { ReactComponent as Settings } from "../../assets/icons/settings.svg";

interface IProps {
  TABS_LIST: string[];
  activation?: "manual" | "automatic";
  ariaLabel: string;
  className?: string;
}

export default ({
  ariaLabel,
  activation = "automatic",
  TABS_LIST,
  className,
}: IProps) => {
  return (
    <TabList aria-label={ariaLabel} activation={activation}>
      {TABS_LIST.map((tab) => {
        return (
          <Tab>
            <div className={className}>
              <span>{tab}</span>
              <Settings />
            </div>
          </Tab>
        );
      })}
    </TabList>
  );
};
